<template>
  <div class="page">
    <div class="tab-wrap">
      <div
        class="tab"
        :class="{ active: tabIndex === 0 }"
        @click="handleTabIndexChange(0)"
      >
        预约
      </div>
      <div
        class="tab"
        :class="{ active: tabIndex === 1 }"
        @click="handleTabIndexChange(1)"
      >
        收藏
      </div>
    </div>
    <van-pull-refresh
      class="list-wrap"
      v-show="tabIndex === 0"
      v-model="appointmentParam.refreshing"
      @refresh="handleAppointmentQuery(true)"
    >
      <van-list
        :immediate-check="false"
        v-model="appointmentParam.loading"
        :finished="appointmentParam.finished"
        finished-text="没有更多数据"
        @load="handleAppointmentQuery"
        ref="appointmentList"
      >
        <div
          class="wrap-item"
          v-for="(item, index) in appointmentParam.list"
          :key="index"
          @click="handleGoDetail(item)"
        >
          <div class="left">
            <div class="img-box">
              <img
                :src="
                  item.activityPicFileUrl ? item.activityPicFileUrl : defaultImg
                "
                alt="活动海报"
              />
            </div>
          </div>
          <div class="right">
            <h2
              v-text="item.activityTitle"
              class="van-multi-ellipsis--l2"
            ></h2>
            <div class="information">
              <div
                class="column"
                v-if="item.activityType2 !== '2'"
              >
                <span class="title">开始时间：</span>
                <span
                  class="message"
                  v-text="item.activityBegintimeStr"
                ></span>
              </div>
              <div
                class="column"
                v-if="item.activityType2 !== '2'"
              >
                <span class="title">结束时间：</span>
                <span
                  class="message"
                  v-text="item.activityEndtimeStr"
                ></span>
              </div>
              <div
                class="column"
                v-if="item.openingHours"
              >
                <span class="title">开放时间：</span>
                <span
                  class="message"
                  v-text="item.openingHours"
                ></span>
              </div>
              <div
                class="column"
                v-if="item.remainderDays"
              >
                <span class="title">剩余天数：</span>
                <span
                  class="message"
                  v-text="item.remainderDays"
                ></span>
              </div>
              <div
                class="column"
                v-show="item.activityType1 != '1' && item.activityPresenter"
              >
                <span class="title">主讲人：</span>
                <span
                  class="message"
                  v-text="item.activityPresenter"
                ></span>
              </div>
              <div
                v-if="item.activityAddress"
                class="column"
              >
                <span class="title">活动地点：</span>
                <span
                  class="message"
                  v-text="item.activityAddress"
                ></span>
              </div>
              <div
                v-if="item.activityComments"
                class="column van-multi-ellipsis--l2"
              >
                <span class="title">活动简介：</span>
                <span
                  class="message"
                  v-text="item.activityComments"
                ></span>
              </div>
              <div class="column">
                <span class="title">活动类型：</span>
                <span
                  class="message"
                  :class="`color1`"
                >
                  <!-- 活动类型为2是培训 -->
                  {{
                    item.activityType1 == "2"
                      ? `${
                          typeOneMap[item.activityType1] +
                          "-" +
                          typeTwoMap[item.activityType2]
                        }`
                      : `${typeOneMap[item.activityType1]}`
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-pull-refresh
      class="list-wrap"
      v-show="tabIndex === 1"
      v-model="favoriteParam.refreshing"
      @refresh="handleFavoriteQuery(true)"
    >
      <van-list
        :immediate-check="false"
        v-model="favoriteParam.loading"
        :finished="favoriteParam.finished"
        finished-text="没有更多数据"
        @load="handleFavoriteQuery"
        ref="favoriteList"
      >
        <div
          class="wrap-item"
          v-for="(item, index) in favoriteParam.list"
          :key="index"
          @click="handleGoDetail(item)"
        >
          <div class="left">
            <div class="img-box">
              <img
                :src="item.activityPicFileUrl"
                alt="活动海报"
              />
            </div>
          </div>
          <div class="right">
            <h2
              v-text="item.activityTitle"
              class="van-multi-ellipsis--l2"
            ></h2>
            <div class="information">
              <div
                class="column"
                v-if="item.activityType2 !== '2'"
              >
                <span class="title">开始时间：</span>
                <span
                  class="message"
                  v-text="item.activityBegintimeStr"
                ></span>
              </div>
              <div
                class="column"
                v-if="item.activityType2 !== '2'"
              >
                <span class="title">结束时间：</span>
                <span
                  class="message"
                  v-text="item.activityEndtimeStr"
                ></span>
              </div>
              <div
                class="column"
                v-if="item.openingHours"
              >
                <span class="title">开放时间：</span>
                <span
                  class="message"
                  v-text="item.openingHours"
                ></span>
              </div>
              <div
                class="column"
                v-if="item.remainderDays"
              >
                <span class="title">剩余天数：</span>
                <span
                  class="message"
                  v-text="item.remainderDays"
                ></span>
              </div>
              <div
                class="column"
                v-show="item.activityType1 != '1' && item.activityPresenter"
              >
                <span class="title">主讲人：</span>
                <span
                  class="message"
                  v-text="item.activityPresenter"
                ></span>
              </div>
              <div
                v-if="item.activityAddress"
                class="column"
              >
                <span class="title">活动地点：</span>
                <span
                  class="message"
                  v-text="item.activityAddress"
                ></span>
              </div>
              <div
                v-if="item.activityComments"
                class="column van-multi-ellipsis--l2"
              >
                <span class="title">活动简介：</span>
                <span
                  class="message"
                  v-text="item.activityComments"
                ></span>
              </div>
              <div class="column">
                <span class="title">活动类型：</span>
                <span
                  class="message"
                  :class="`color1`"
                >
                  <!-- 活动类型为2是培训 -->
                  {{
                    item.activityType1 == "2"
                      ? `${
                          typeOneMap[item.activityType1] +
                          "-" +
                          typeTwoMap[item.activityType2]
                        }`
                      : `${typeOneMap[item.activityType1]}`
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import { getSelectList } from "@/api/common";
import {
  activityAppointmentListGet,
  activityFavoriteListGet,
} from "@/api/my-activity";
import {
  STATUS_CODE_OK,
  DICT_T_ACTIVITY_TYPE_ONE,
  DICT_T_ACTIVITY_TYPE_TWO,
} from "@/config";
import { SelectListToMap } from "@/utils";
export default {
  name: "MyActivity",
  data() {
    return {
      activityTypeList: [], // 活动类型列表
      typeTwo: [],
      tabIndex: 0, // 被选中的tab
      appointmentParam: {
        loading: false,
        finished: false,
        refreshing: false,
        pageNo: 1,
        pageSize: 10,
        list: [],
      },
      favoriteParam: {
        loading: false,
        finished: false,
        refreshing: false,
        pageNo: 1,
        pageSize: 10,
        list: [],
      },
      defaultImg: require("@/assets/images/peixun.jpg"),
    };
  },
  computed: {
    // 活动类型1
    typeOneMap() {
      return SelectListToMap(this.activityTypeList);
    },
    // 活动类型2
    typeTwoMap() {
      return SelectListToMap(this.typeTwo);
    },
  },
  async mounted() {
    await this.handleActivityListGet();
    await this.handleActivityTypeTwoList();
    this.$nextTick(() => {
      this.$refs.appointmentList && this.$refs.appointmentList.check();
      this.$refs.favoriteList && this.$refs.favoriteList.check();
    });
  },
  methods: {
    // tab改变事件
    handleTabIndexChange(val = 0) {
      this.tabIndex = val
      this.$nextTick(() => {
        this.$refs.appointmentList && this.$refs.appointmentList.check();
        this.$refs.favoriteList && this.$refs.favoriteList.check();
      });
    },
    // 获取活动类型词典
    async handleActivityListGet() {
      let { data } = await getSelectList({
        dictTable: DICT_T_ACTIVITY_TYPE_ONE,
      });
      if (data.code === STATUS_CODE_OK) {
        this.activityTypeList = data.data;
      }
    },
    // 获取活动类型2
    async handleActivityTypeTwoList() {
      let { data } = await getSelectList({
        dictTable: DICT_T_ACTIVITY_TYPE_TWO,
      });
      if (data.code === STATUS_CODE_OK) {
        this.typeTwo = data.data;
      }
    },
    // 预约查询
    async handleAppointmentQuery(isRefresh = false) {
      const that = this;
      if (isRefresh) {
        that.appointmentParam.pageNo = 1;
        that.appointmentParam.loading = true;
        that.appointmentParam.finished = false;
      }
      let { data } = await activityAppointmentListGet({
        pageNo: that.appointmentParam.pageNo,
        pageSize: that.appointmentParam.pageSize,
      });
      if (data.code === STATUS_CODE_OK) {
        that.appointmentParam.refreshing = false;
        that.appointmentParam.loading = false;
        that.appointmentParam.finished =
          data.data.hasMore === "Y" ? false : true;
        that.appointmentParam.pageNo++;
        if (isRefresh) {
          that.appointmentParam.list = data.data.result;
        } else {
          that.appointmentParam.list = that.appointmentParam.list.concat(
            data.data.result
          );
        }
      }
    },
    // 收藏查询
    async handleFavoriteQuery(isRefresh = false) {
      const that = this;
      if (isRefresh) {
        that.favoriteParam.pageNo = 1;
        that.favoriteParam.finished = false;
        that.favoriteParam.loading = true;
      }
      let { data } = await activityFavoriteListGet({
        pageNo: that.favoriteParam.pageNo,
        pageSize: that.favoriteParam.pageSize,
      });
      if (data.code === STATUS_CODE_OK) {
        that.favoriteParam.refreshing = false;
        that.favoriteParam.loading = false;
        that.favoriteParam.finished = data.data.hasMore === "Y" ? false : true;
        that.favoriteParam.pageNo++;
        if (isRefresh) {
          that.favoriteParam.list = data.data.result;
        } else {
          that.favoriteParam.list = that.favoriteParam.list.concat(
            data.data.result
          );
        }
      }
    },
    // 跳转活动详情页
    handleGoDetail(item) {
      this.$router.push({
        path: "/activityDetail",
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  background-color: #f7f8fa;
  .tab-wrap {
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    height: 58px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 666;
    border-bottom: 1px solid #eee;
    .tab {
      color: #1282f4;
      padding: 8px 0;
      border: 1px solid #1282f4;
      width: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      &.active {
        color: #fff;
        background-color: #1282f4;
      }
    }
  }
  .list-wrap {
    position: fixed;
    top: 58px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 666;
    overflow-y: auto;
    .wrap-item {
      margin-bottom: 10px;
      background: #fff;
      padding: 10px 10px;
      display: flex;
      justify-content: space-between;
      .left {
        width: 125px;
        height: 170px;
        flex: none;
        .img-box {
          width: 100%;
          height: 100%;
          text-align: center;
          img {
            width: 100%;
            height: 100%;
            border-radius: 8px;
            object-fit: cover;
          }
        }
      }
      .right {
        padding-left: 10px;
        flex: 1;
        h2 {
          font-size: 14px;
          font-weight: normal;
          margin: 10px 0;
          width: 200px;
        }
        .information {
          font-size: 12px;
          color: #969799;
          .column {
            margin-bottom: 5px;
            .title {
              display: inline-block;
              width: 70px;
            }
            .message {
              &.color1 {
                color: #1989fa;
              }
              &.color2 {
                color: #07c160;
              }
              &.color3 {
                color: #ff976a;
              }
              &.color4 {
                color: #ee0a24;
              }
            }
          }
        }
      }

      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
}
</style>
